"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Chevron = exports.ChevronDirection = exports.TEST_ID_CHEVRON = void 0;
/** @jsxRuntime classic */
/** @jsx jsx */
var theme_ui_1 = require("theme-ui");
var colors_1 = __importDefault(require("../../../theme/colors"));
exports.TEST_ID_CHEVRON = "chevron";
var chevronGirth = 40;
var ChevronDirection;
(function (ChevronDirection) {
    ChevronDirection["UP"] = "up";
    ChevronDirection["RIGHT"] = "right";
    ChevronDirection["DOWN"] = "down";
    ChevronDirection["LEFT"] = "left";
})(ChevronDirection = exports.ChevronDirection || (exports.ChevronDirection = {}));
function Chevron(_a) {
    var _b = _a.direction, direction = _b === void 0 ? ChevronDirection.RIGHT : _b, csx = _a.csx;
    var clipPath = "";
    var height = "12px";
    var width = "8px";
    switch (direction) {
        case ChevronDirection.UP:
            clipPath = "polygon(0% " + (100 - chevronGirth) + "%, 50% 0, 100% " + (100 - chevronGirth) + "%, 100% 100%, 50% " + chevronGirth + "%, 0% 100%)";
            height = "8px";
            width = "12px";
            break;
        case ChevronDirection.RIGHT:
            clipPath = "polygon(0 0, " + chevronGirth + "% 0, 100% 50%, " + chevronGirth + "% 100%, 0 100%, " + (100 - chevronGirth) + "% 50%)";
            break;
        case ChevronDirection.DOWN:
            clipPath = "polygon(0% 0%, 50% " + (100 - chevronGirth) + "%, 100% 0%, 100% " + chevronGirth + "%, 50% 100%, 0% " + chevronGirth + "%)";
            height = "8px";
            width = "12px";
            break;
        case ChevronDirection.LEFT:
            clipPath = "polygon(0% 50%, " + (100 - chevronGirth) + "% 0%, 100% 0%, " + chevronGirth + "% 50%, 100% 100%, " + (100 - chevronGirth) + "% 100%)";
            break;
    }
    return (theme_ui_1.jsx(theme_ui_1.Box, { as: "span", "data-testid": exports.TEST_ID_CHEVRON, sx: __assign({ background: colors_1.default.primary, clipPath: clipPath, display: "inline-block", height: height, ml: 1, width: width }, csx) }));
}
exports.Chevron = Chevron;
